module.exports = __webpack_public_path__ + "img/warning_orange.ad7817e9.svg";